import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { UseCases } from "@planzone/core";
import { useAuthentication } from "@planzone/view-models";
import { Identifiable, Task } from "@planzone/dto";
import { useModal } from "@root/client/modal";
import { Props } from "./types";
import styles from "./styles.scss";

function isTaskLate({ endDate }: Identifiable<Task>) {
  return endDate && new Date(endDate) < new Date();
}

function isTaskDone({ percentComplete, status }: Identifiable<Task>) {
  return percentComplete === 100 || status.percentComplete === 100;
}

function Tasks({ tasks, placeholder, isEveryoneDisplayed }: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();
  const { account } = useAuthentication();
  const filterTask = (task: Identifiable<Task>) =>
    !!task.allocations
      .map((allocation) => allocation.resource)
      .find((resource) => resource.uuid === account.resource.uuid);
  const filteredTasks = !isEveryoneDisplayed ? tasks.filter(filterTask) : tasks;

  return (
    <div className={styles.tasks}>
      {filteredTasks.length === 0 ? (
        <div className={styles.placeholder}>{<p>{placeholder}</p>}</div>
      ) : (
        <div className={styles.list}>
          {filteredTasks.map((task) => (
            <div
              key={task.uuid}
              className={classNames(styles.task, {
                [styles.late]: isTaskLate(task) && !isTaskDone(task),
              })}
              onClick={() =>
                pushView({
                  key: UseCases.retrieveTask,
                  data: { task, isMultiProject: true },
                })
              }
            >
              <p className={styles.name}>{task.name}</p>
              <div>
                <div
                  className={styles.status}
                  style={{ backgroundColor: task.status.color }}
                >
                  <p className={styles.statusName}>
                    {t(`taskStatuses.${task.status.label}`, task.status.label)}
                  </p>
                </div>
              </div>
              {task.endDate ? (
                <p className={styles.endDate}>
                  {new Date(task.endDate).toLocaleDateString()}
                </p>
              ) : (
                <p className={styles.endDate} />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export { Tasks };
